export default __webpack_public_path__ + "static/media/img_9.41723078.jpg";